import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { HistoryElement, useAppStateSelector } from "@nosto/preact"
import { trendingSearches } from "../helpers"
import { useEffect } from "preact/hooks"

export default function History() {
    const historyItems = useAppStateSelector(state => state.historyItems)

    // if (!historyItems || !historyItems.length) {
    //     return
    // }

    useEffect(()=>{
        if(window.nostojs){
            window.nostojs(api => {
                api
                .createRecommendationRequest({ includeTagging: true })
                .setElements([ "ns-autocomplete-rec" ])
                .load({ skipPageViews: true, skipEvents: true })
            })
        }
    }, [])

    return (
        <div class="ns-autocomplete ns-autocomplete-history ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto">
            <div class="ns-w-100 ns-mt-sm-auto">
            {/* ns-py-2 ns-px-4 */}
                <div class="ns-color-black ns-font-bold ns-font-5 ns-d-flex ns-history-heading">
                    <img class="ns-trending-icon" src="https://d21m4dsqdd3b9h.cloudfront.net/bigcommerce-f4083/onsiteContent/17477354465220.04024281702982191" alt="Trending Icon" />
                    Popular Searches
                </div>
                {trendingSearches && <div class="ns-top-categories">
                    {/* <div 
                        class="ns-color-black ns-font-medium ns-pb-3 ns-pb-md-2 ns-autocomplete-heading"
                        tabIndex="0"
                        role="heading"
                        aria-level="2"
                    >
                        TRENDING SEARCHES
                    </div> */}
                    <div class="ns-d-flex ns-flex-column">
                        {(window.nostoTrendingSearches || trendingSearches).map((item, index)=>{
                            return (
                                <a href={item?.url} class="ns-top-category ns-text-undecorated ns-clickable ns-py-2 ns-font-4">{item?.name}</a>
                            )
                        })}        
                    </div>
                </div>}
                {/* ns-py-2 ns-px-4  */}
                <div class="ns-color-black ns-font-bold ns-font-5 ns-d-flex ns-history-heading">
                    <img class="ns-trending-icon" src="https://d21m4dsqdd3b9h.cloudfront.net/bigcommerce-f4083/onsiteContent/17477354465220.04024281702982191" alt="Trending Icon" />
                    Trending Products
                </div>
                <div class="nosto_element" id="ns-autocomplete-rec"></div>
            </div>
        </div>
    )
}
